<template>
  <v-row>
    <v-col
      ><v-select
        dense
        label="Institution Group"
        placeholder="Institution Group"
        class="white"
        :items="institution"
        item-text="name"
        outlined
        v-model="item"
        item-value="id"
      ></v-select
    ></v-col>
  </v-row>
</template>

<script>
export default {
  props: ["callbackSelect"],
  data: () => ({
    institution:[],
    id: null,
    item: '',
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  watch: {
    item: function (val) {
      this.item = val
      this.callbackSelect(val);
    },
  },
  created() {
    this.api.method = "get";
    this.api.url =`${this.$api.servers.event}/api/v1/en/data/event/${this.$route.params.id}/institutionGroup`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.institution = resp;
       
      this.item = resp[0].id
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
};
</script>

<style>
</style>